import React, { useEffect } from 'react';

type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
  type?: ToastType;
  message: string;
  onClose: () => void;
  durationMs?: number;
}

export const Toast: React.FC<ToastProps> = ({ type = 'info', message, onClose, durationMs = 3500 }) => {
  useEffect(() => {
    const id = setTimeout(onClose, durationMs);
    return () => clearTimeout(id);
  }, [durationMs, onClose]);

  const bg = type === 'success' ? 'bg-green-50 text-green-800' : type === 'error' ? 'bg-red-50 text-red-800' : 'bg-blue-50 text-blue-800';

  return (
    <div className={`flex items-center gap-2 px-4 py-3 rounded-lg shadow-sm border ${bg}`}>
      <span className="text-sm font-medium">{message}</span>
      <button className="ml-auto text-xs underline" onClick={onClose}>Dismiss</button>
    </div>
  );
};
